import { useQuery } from "@apollo/client";
import { CATEGORY_INSTALL_COUNT_QUERY } from "./queries/categoryInstallCountQuery";
import { useProductCatalogContext } from "../ProductCatalogContext";
import { NumberCard } from "../components/NumberCard";
import { COMPANY_SEARCH_CLIENT } from "../../../utils/consts";

export const InstallCountCard = (props: { leafCategoryIds: string[] }) => {
  const { entityTypeFilterValue, localizeInstalls } =
    useProductCatalogContext();

  const { data, loading } = useQuery(CATEGORY_INSTALL_COUNT_QUERY, {
    variables: {
      categoryIds: props.leafCategoryIds,
      localizeInstalls,
      ...entityTypeFilterValue,
    },
    skip: props.leafCategoryIds.length === 0,
    context: { clientName: COMPANY_SEARCH_CLIENT },
  });

  return (
    <NumberCard
      id="install-count"
      isLoading={loading}
      count={data?.productCatalogInstallsCount.count || 0}
      title="Number of Installs"
    />
  );
};
